import React from 'react'
import { l } from '@manychat/manyui'

import cm from './EmptyState.module.css'

export const EmptyState = () => {
  return (
    <div className={cm.wrapper}>
      <div className={cm.content}>
        <h2 className="text-subheading text-center">{l.translate('Preview')}</h2>

        <p className="m-t-xs text-center">
          {l.translate('See how AI turns the info you shared into answers for your audience')}
        </p>
      </div>
    </div>
  )
}
